import React from "react"
import {serverSideTranslations} from "next-i18next/serverSideTranslations"
import NavBar from "../../components/navigation/NavBar"
import FilterContextProvider from "../../provider/FilterContextProvider"
import Footer from "../../components/footer/Footer"
import nextI18NextConfig from "../../next-i18next.config.js"
import {useTranslation} from "next-i18next"
import MbpHead from "../../components/head/MbpHead"
import BikesCollectionContainer from "../../components/bikesCollection/BikesCollectionContainer"
import {getPageData} from "../../pageData"
import {getTotalProductCount, handleInclusiveCategories} from "../../utility/SqlQueryFunctions"
import {executeSqlQuery, getBikesWithOffsetAndLimit} from "../../postgres/selectHelpers/selectQuery"
import {strapiCollections} from "../../utility/strapi/collections"

type Props = {
	productsCount: number
     nextPage?: number
    currentPage?: number
    totalPages?: number,
};

const AllBikes: React.FC<Props> = ({productsCount, totalPages, nextPage, currentPage}) => {
	const {t} = useTranslation()
	const title = t("MyBikePlan | Alle E-Bike Modelle | Auf Raten mit 0% Zins")
	const description = t("Möchtest Du ein E-Bike besitzen? Schaue unsere Auswahl an und bestelle jetzt Dein E-Bike für ab CHF 52 im Monat!")
	return (
		<>
			<MbpHead>
				<title>
					{title}
				</title>
				<meta name="description"
					content={description}/>
				<meta property="og:title"
					content={title}/>
				<meta property="og:description"
					content={description}/>
				<meta property="og:image"
					content={"/assets/images/favicon.png"}/>
			</MbpHead>
			<div className="position-relative">
				<NavBar stickyTop={false} />
				<FilterContextProvider>
					<BikesCollectionContainer productsCount={productsCount} />
				</FilterContextProvider>
				<Footer/>
			</div>
		</>
	)
}

export async function getStaticProps({locale, req}) {
	const bikesList = await getBikesWithOffsetAndLimit(
		locale,
		null,
		["categories", "images", "attributes"],
		["brand", "speed", "test_drive", "bike-rental"],
		0,
		20)
	const categories = await handleInclusiveCategories({}, locale)

	const countTotalNumberOfBikesQueryText = getTotalProductCount(categories, {categories: "-"}, locale)
	const count = await executeSqlQuery(countTotalNumberOfBikesQueryText)

	const pageData = (await getPageData(locale, [], [], [strapiCollections.stories]))

	return {
		props: {
			...pageData,
			bikesList,
			// eslint-disable-next-line
			productsCount: count[0]["totalnumberofproducts"],
			...(await serverSideTranslations(locale, ["common", "productDescrPage", "filters", "PDPTiles", "banners", "URL", "search", "sponsorship", "insurance"], nextI18NextConfig))
		}
	}
}

export default AllBikes
